import { render, staticRenderFns } from "./locationsList.vue?vue&type=template&id=dd4af226"
import script from "./locationsList.vue?vue&type=script&lang=js"
export * from "./locationsList.vue?vue&type=script&lang=js"
import style0 from "./locationsList.vue?vue&type=style&index=0&id=dd4af226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports